<div class="table-content-component-panel-monitoreo" style="position: relative; overflow: auto;">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingAlertsSpinner" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <p style="color: white">{{ 'ALERTS.MESSAGE.LOADING' | translate }}</p>
  </ngx-spinner>

  <!-- 🔽 EX-CAPTION: Controles superiores -->
  <div class="d-flex flex-column col-12 mb-2">
    <div class="d-flex justify-content-between align-items-center px-2 gap-2 py-2">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Filtrar por nombre o tipo..." [(ngModel)]="globalFilterValue"
          (input)="aplicarFiltroGlobal()" class="w-100" />
      </span>


      <button type="button"
        *ngIf="alertService.alertConfig.controls.views"
        class="btn btn-light border rounded-circle p-2 d-flex justify-content-center align-items-center"
        (click)="showGroupAlerts()" [pTooltip]="showByTable ? 'Ver agrupado' : 'Ver en tabla'" tooltipPosition="top">
        <i class="pi" [ngClass]="showByTable ? 'pi-list' : 'pi-table'" style="font-size: 1.2rem;"></i>
      </button>
      <div class="d-flex flex-row gap-1"
        *ngIf="
          alertService.alertConfig.create.gps ||
          alertService.alertConfig.create.platform ||
          alertService.alertConfig.create.security ||
          alertService.alertConfig.create.mobile ||
          alertService.alertConfig.create.fatigue360
        "
      >
        <ng-container *ngIf="isAll == false">
          <button *appHasPermission="'alerts_new_create'" type="button"
            class="btn-gl-blue btn-dark-hover btn-circle flex-none me-2" (click)="clickCreateNewAlert()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </ng-container>

        <div ngbDropdown container="body" placement="right-top left-top" class="flex-none" *appHasPermission="'alerts_new_create'">
          <button class="btn-gl-gray-blue btn-dark-hover btn-circle" ngbDropdownToggle>
            <i class="fa fa-fw fa-plus fa-1" aria-hidden="true"></i>
          </button>

          <div ngbDropdownMenu class="gl-custom-dropdown dropdown-alert-panel">
            <ng-container *ngIf="alertService.alertsPermission$ | async as permissions">

              <!-- GPS -->
              <div
                *ngIf="permissions.includes('gps') && alertService.alertConfig.create.gps"
                ngbDropdownItem
                (click)="panelService.clickHeaderToggle('ALERTS-GPS-CREATE')"
              >
                <span>{{ 'ALERTS.OPTIONS.GPS_TRACKER' | translate }}</span>
              </div>

              <!-- Plataforma -->
              <div
                *ngIf="permissions.includes('platform') && alertService.alertConfig.create.platform"
                ngbDropdownItem
                (click)="panelService.clickHeaderToggle('ALERTS-PLATFORM-CREATE')"
              >
                <span>{{ 'ALERTS.OPTIONS.PLATFORM' | translate }}</span>
              </div>

              <!-- Seguridad del vehículo -->
              <div
                *ngIf="permissions.includes('security') && alertService.alertConfig.create.security"
                ngbDropdownItem
                (click)="panelService.clickHeaderToggle('ALERTS-SECURITY-CREATE')"
              >
                <span>{{ 'ALERTS.OPTIONS.VEHICLE_SECURITY' | translate }}</span>
              </div>

              <!-- Soluciones móviles -->
              <div
                *ngIf="permissions.includes('mobile') && alertService.alertConfig.create.mobile"
                ngbDropdownItem
                (click)="panelService.clickHeaderToggle('ALERTS-MOBILE-CREATE')"
              >
                <span>{{ 'ALERTS.OPTIONS.MOBILE_SOLUTIONS' | translate }}</span>
              </div>

              <!-- Fatiga 360 -->
              <div
                *ngIf="permissions.includes('360') && alertService.alertConfig.create.fatigue360"
                ngbDropdownItem
                (click)="panelService.clickHeaderToggle('ALERTS-360-CREATE')"
              >
                <span>{{ 'ALERTS.OPTIONS.FATIGUE_360' | translate }}</span>
              </div>

            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- 🔽 Cards -->
  <div *ngIf="!showByTable" class="tree-groups" style="width: 100%;height: 100%;overflow: hidden;overflow-y: auto;  padding-right: 10px">
  
      <ng-container *ngIf="groupedAlertsTree.length > 0; else noGroups">
  
        <div *ngFor="let group of groupedAlertsTree" class="">
          <!-- Encabezado de grupo -->
          <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom tree_section">
            <div class="d-flex align-items-center gap-2">
              <button class="btn btn-sm text-white p-0 border-0 bg-transparent" (click)="group.isOpen = !group.isOpen">
                <i class="pi" [ngClass]="group.isOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </button>
              <span>{{ group.nombre }}</span>
              <span class="badge text-white bg-secondary-subtle text-dark">( {{ group.alerts.length }} )</span>
            </div>
  
            <!-- Controles personalizados -->
            <div class="d-flex align-items-center gap-2">
              <div *appHasPermission="['alerts_old_update', 'alerts_old_delete']" ngbDropdown container="body"
                [autoClose]="true" placement="right-top right-bottom left-top left-bottom">
                <a class="dropdown-toggle icon_media_rem text-white" ngbDropdownToggle>
                  <i class="fa fa-fw fa-bars fa-1" aria-hidden="true"></i>
                </a>
                <div ngbDropdownMenu class="gl-custom-dropdown alert-table-dropdown">
                  <div *appHasPermission="'alerts_old_update'" ngbDropdownItem (click)="panelCreateNewAlert(group.id)">
                    <i class="fa fa-plus" aria-hidden="true"></i> Crear Nueva Alerta
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Cuerpo de alertas dentro del grupo -->
          <div *ngIf="group.isOpen">
            <div class="col-12 d-flex flex-column g-3">
              <div class="col-12" *ngFor="let alert of group.alerts; let i = index">
                <!-- Aquí va la tarjeta de alerta -->
                <div class="card shadow-sm border-0 h-100">
                  <div class="card-body d-flex flex-column gap-2">
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="d-flex flex-row gap-1 align-items-center">
                        <h5 *ngIf="alertService.alertConfig.cardItems.name" class="card-title mb-0 txt-truncate w-100">{{ alert.nombre }}</h5>
                      </div>
  
                      <ng-container *ngIf="alertService.alertConfig.cardItems.options">
                        <div *appHasPermission="['alerts_old_update', 'alerts_old_delete']" ngbDropdown container="body"
                          [autoClose]="true" placement="right-top right-bottom left-top left-bottom">
                          <a class="dropdown-toggle icon_media_rem" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                          </a>
                          <div ngbDropdownMenu class="gl-custom-dropdown alert-table-dropdown">
                            <div *appHasPermission="'alerts_old_update'" ngbDropdownItem (click)="editAlert(alert.id)">
                              <i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{ 'GENERAL.CONFIGURE' | translate }}
                            </div>
                            <div *appHasPermission="'alerts_old_delete'" ngbDropdownItem
                              (click)="deleteAlert($event, alert)">
                              <i class="fa fa-trash-o" aria-hidden="true"></i> {{ 'GENERAL.DELETE' | translate }}
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="d-flex flex-row justify-content-between align-items-center">
                      <div class="d-flex flex-row gap-2 justify-content-between align-items-center">
                        <span *ngIf="alertService.alertConfig.cardItems.isActive" class="badge" [ngClass]="alert.isActive ? 'badge-success' : 'badge-danger'"
                          title="{{ alert.isActive ? 'Activo' : 'Inactivo' }}">
                          {{ alert.isActive ? 'Activo' : 'Inactivo' }}
                        </span>
                        <span *ngIf="alertService.alertConfig.cardItems.type" class="text-muted small badge badge-info">{{ alert.tipo }}</span>
  
                        <span class="badge badge-info" *ngIf="alertService.alertConfig.cardItems.imeiCount">
                          <p class="text-muted small mb-0">
                            {{ alert.imeiCount }}
                            <i class="fas fa-truck"></i>
                            {{ alert.imeiCount === 1 ? 'unidad' : 'unidades' }}
                          </p>
                        </span>
  
                      </div>
                      <div class="d-flex flex-row mt-auto align-items-center justify-content-between">
  
                        <div class="d-flex flex-row gap-3">
                          <div pTooltip="Sonido del sistema" tooltipPosition="top" *ngIf="alertService.alertConfig.cardItems.isActiveSoundSystem">
                            <i class="fas"
                              [ngClass]="alert.isActiveSoundSystem ? 'fa-volume-up text-success' : 'fa-volume-mute text-muted opacity-75'"
                              style="font-size: 1.2rem;"></i>
                          </div>
                          <div *ngIf="group.id == '360' && alert.isActiveNotificationWhatsapp && alertService.alertConfig.cardItems.isActiveNotificationWhatsapp" pTooltip="Notificación por WhatsApp" tooltipPosition="top">
                            <i class="fab"
                              [ngClass]="alert.isActiveNotificationWhatsapp ? 'fa-whatsapp text-success' : 'fa-whatsapp text-muted opacity-75'"
                              style="font-size: 1.2rem;"></i>
                          </div>
                          <div *ngIf="alertService.alertConfig.cardItems.isActiveNotificationEmail" pTooltip="Envío de correo" tooltipPosition="top">
                            <i class="fas"
                              [ngClass]="alert.isActiveNotificationEmail ? 'fa-envelope-open-text text-success' : 'fa-envelope text-muted opacity-75'"
                              style="font-size: 1.2rem;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
  
                  </div>
                </div>
                <!-- Fin tarjeta -->
              </div>
              <div *ngIf="group.alerts.length === 0" class="col-12 text-center text-muted py-3">
                <i class="pi pi-info-circle me-2"></i>
                No hay alertas registradas en este grupo.
              </div>
  
            </div>
          </div>
        </div>
      </ng-container>
  
      <ng-template #noGroups>
        <div class="text-center text-muted py-3">
          No hay alertas configuradas
        </div>
      </ng-template>
  </div>
  
  <!-- 🔽 Tabla -->
  <ng-container *ngIf="showByTable">
    <p-table #dt [value]="filteredAlerts" styleClass="p-datatable-sm"
      [scrollable]="true" 
      scrollHeight="calc(100vh - 90px - calc(calc(calc(var(--navbar-height) + var(--row-busqueda-height)) + calc(var(--pm-vehiculos-header-height) + var(--treetable-header-height)))))"
      [globalFilterFields]="['nombre']">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="alertService.alertConfig.tableColumns.index" style="width: 8%;" class="text-center" pSortableColumn="index">
            N.º
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.name" style="width: 32%;" class="text-start" pSortableColumn="nombre">
            {{ 'ALERTS.LABEL.NAME' | translate }}
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.imeiCount" style="width: 14%;" class="text-center icon_media_rem" pSortableColumn="imeiCount"
            pTooltip="Número de unidades">
            <i class="fas fa-truck"></i>
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.isActive" style="width: 14%;" class="text-center" pSortableColumn="isActive">
            {{ 'ALERTS.LABEL.ACTIVE' | translate }}
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.isActiveSoundSystem" style="width: 12%;" class="text-center icon_media_rem" pSortableColumn="isActiveSoundSystem"
            pTooltip="Sonido del sistema">
            <i class="far fa-bell"></i>
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.isActiveNotificationEmail" style="width: 10%;" class="text-center icon_media_rem" pSortableColumn="isActiveNotificationEmail"
            pTooltip="Envío de correo">
            <i class="fas fa-at"></i>
          </th>
          <th *ngIf="alertService.alertConfig.tableColumns.options" style="width: 12%;" class="text-center icon_media_rem" pTooltip="Opciones">
            <i class="fas fa-ellipsis-v"></i>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-alert let-i="rowIndex">
        <tr>
          <td *ngIf="alertService.alertConfig.tableColumns.index" class="text-center" style="width: 8%;">{{ i + 1 }}</td>
          <td *ngIf="alertService.alertConfig.tableColumns.name" class="text-start" style="width: 32%;">{{ alert?.nombre }}</td>
          <td *ngIf="alertService.alertConfig.tableColumns.imeiCount" class="text-center" style="width: 14%;">{{ alert?.imeiCount }}</td>
          <td *ngIf="alertService.alertConfig.tableColumns.isActive" class="text-center" style="width: 14%;">
            <span class="badge" [ngClass]="alert.isActive ? 'badge-success' : 'badge-danger'"
              title="{{ alert.isActive ? 'Activo' : 'Inactivo' }}">
              {{ alert.isActive ? 'Activo' : 'Inactivo' }}
            </span>
          </td>
          <td *ngIf="alertService.alertConfig.tableColumns.isActiveSoundSystem" class="text-center" style="width: 12%;">
            <i class="fa"
              [ngClass]="alert.isActiveSoundSystem ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"
              aria-hidden="true" title="{{ alert.isActiveSoundSystem ? 'Activo' : 'Inactivo' }}"></i>
          </td>
          <td *ngIf="alertService.alertConfig.tableColumns.isActiveNotificationEmail" class="text-center" style="width: 10%;">
            <i class="fa"
              [ngClass]="alert.isActiveNotificationEmail ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"
              aria-hidden="true" title="{{ alert.isActiveNotificationEmail  ? 'Activo' : 'Inactivo' }}"></i>
          </td>
          <td *ngIf="alertService.alertConfig.tableColumns.options" class="text-center icon_media_rem" style="width: 12%;">
            <div *appHasPermission="['alerts_old_update', 'alerts_old_delete']" ngbDropdown container="body"
              [autoClose]="true" placement="right-top right-bottom left-top left-bottom">
              <a class="dropdown-toggle icon_media_rem" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </a>
              <div ngbDropdownMenu class="gl-custom-dropdown alert-table-dropdown">
                <div *appHasPermission="'alerts_old_update'" ngbDropdownItem (click)="editAlert(alert.id)">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{ 'GENERAL.CONFIGURE' | translate }}
                </div>
                <div *appHasPermission="'alerts_old_delete'" ngbDropdownItem (click)="deleteAlert($event, alert)">
                  <i class="fa fa-trash-o" aria-hidden="true"></i> {{ 'GENERAL.DELETE' | translate }}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            {{ noResults ? ('ALERTS.MESSAGE.NO_MATCH' | translate) : ('ALERTS.MESSAGE.NO_ALERTS_CONFIGURED' | translate)
            }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</div>